import { useState } from 'react';
import { syncDraft } from '../offline/sync';

function RefreshIcon({ spinning }) {
  return (
    <svg viewBox="0 0 24 24" className={`h-4 w-4 ${spinning ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12a9 9 0 1 1-2.64-6.36" />
      <path d="M21 3v6h-6" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
  );
}

const STYLES = {
  idle: 'border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100',
  syncing: 'border-blue-300 bg-blue-50 text-blue-700',
  done: 'border-emerald-300 bg-emerald-50 text-emerald-700',
  error: 'border-red-300 bg-red-50 text-red-700 hover:bg-red-100',
};

// زر بجانب الفحص غير المرفوع: ↻ ينتظر الرفع، يدور أثناء الرفع، ✓ بعد نجاحه، ! عند الفشل (الضغط يعيد المحاولة).
export default function SyncIconButton({ draftId, lastError = '', onSynced, size = 'md' }) {
  const [state, setState] = useState(lastError ? 'error' : 'idle');
  const [message, setMessage] = useState(lastError);

  const run = async () => {
    if (state === 'syncing' || state === 'done') return;
    setState('syncing');
    setMessage('');
    const result = await syncDraft(draftId);
    if (result.ok) {
      setState('done');
      onSynced?.(result);
      return;
    }
    setState('error');
    setMessage(result.error || 'تعذّر الرفع.');
  };

  const titles = {
    idle: 'لم يُرفع إلى الخادم — اضغط للمزامنة',
    syncing: 'جاري الرفع...',
    done: 'تمت المزامنة',
    error: `فشل الرفع: ${message} — اضغط لإعادة المحاولة`,
  };

  const dimension = size === 'sm' ? 'h-7 w-7' : 'h-8 w-8';

  return (
    <button
      type="button"
      onClick={run}
      disabled={state === 'syncing' || state === 'done'}
      title={titles[state]}
      aria-label={titles[state]}
      className={`inline-flex ${dimension} shrink-0 items-center justify-center rounded-full border transition ${STYLES[state]}`}
    >
      {state === 'done' && <CheckIcon />}
      {state === 'error' && <span className="text-sm font-black leading-none">!</span>}
      {(state === 'idle' || state === 'syncing') && <RefreshIcon spinning={state === 'syncing'} />}
    </button>
  );
}
